import React, { Component } from 'react';
import { Link } from 'react-router-dom';

const Image = props => {
    const { src, className, alt, style, height, width } = props;
    return (
        <img
            src={src}
            className={className}
            alt={alt?alt:'Image'}
            style={style?style:{}}
            height={height?height:null}
            width={width?width:null}
        />
    );
}

export default Image;